import { createHttpLink } from '@apollo/client/core'

import { hygraphGraphqlUrl } from '@/config/env'

const hygraphHttpLink = createHttpLink({
  uri: hygraphGraphqlUrl,
})

export default hygraphHttpLink
